import React from 'react';
import {
  Avatar,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import type { IJobUnavailableProps } from '../../interfaces';

export const JobUnavailable = ({ jobPostData }: IJobUnavailableProps) => (
  <Container maxWidth="lg" sx={{ py: 8 }}>
    <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center' }}>
      <Avatar sx={{ width: 80, height: 80, bgcolor: 'grey.100', color: 'text.disabled' }}>
        <SearchOffIcon fontSize="large" />
      </Avatar>
      <Typography variant="h2">Job Post Unavailable</Typography>
      <Typography variant="body1" color="text.secondary">
        {jobPostData
          ? 'This job posting is currently inactive or has been removed.'
          : 'The requested job posting could not be found.'}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Please check back later or browse our other opportunities.
      </Typography>
    </Stack>
  </Container>
);
